import React from 'react'
import styles from './AcceptModal.module.scss'

const AcceptModal = ({ onClose, onAccept }) => {
	return (
		<div className={styles.acceptModalContainer}>
			<span className={styles.acceptModalTitle}>제안을 수락하시겠어요?</span>
			<span className={styles.acceptModalDescription}>
				제안을 수락하면, 조건 협상이 마무리 돼요.
				<br />
				그리고 '계약'을 제안받을 확률이 높아져요!
			</span>
			<div className={styles.acceptButtonContainer}>
				<button className={styles.acceptCancelButton} onClick={onClose}>
					취소
				</button>
				<button className={styles.acceptConfirmButton} onClick={onAccept}>
					제안 수락하기
				</button>
			</div>
		</div>
	)
}

export default AcceptModal
